import { getSiblings } from "../../helpers";

export default class Accordion {
	constructor(element) {
		if (!element) return;

		this.accordion = element;
		this.headings = Array.from(
			this.accordion.querySelectorAll(".accordion-heading")
		);

		this.events();
		this.afterInit();
	}

	afterInit() {
		if (this.accordion.dataset?.autoOpen === "false") return;
		this.headings[0].dispatchEvent(new Event("click"));
	}

	onHeadingClick(event) {
		const heading = event.currentTarget;
		const button = heading.querySelector("button");
		const content = document.getElementById(
			button.getAttribute("aria-controls")
		);
		const contentHeight = content.scrollHeight + "px";

		if (content.style.maxHeight) {
			content.style.maxHeight = null;
			button.setAttribute("aria-expanded", "false");
			heading.classList.remove("active");
		} else {
			content.style.maxHeight = contentHeight;
			button.setAttribute("aria-expanded", "true");
			heading.classList.add("active");

			Array.from(getSiblings(content.closest(".accordion-item"))).map((el) => {
				el.querySelector(".accordion-heading").classList.remove("active");
				el.querySelector(".accordion-heading button").setAttribute(
					"aria-expanded",
					"false"
				);
				el.querySelector(".accordion-content").style.maxHeight = null;
			});
		}
	}

	events() {
		this.headings.map((heading) =>
			heading.addEventListener("click", this.onHeadingClick.bind(this), false)
		);
	}
}
